import React from "react";
import DepartmentCombobox from "components/directus/department-combobox";
import CalendarDatePicker from "ui/components/comp-507";
import { formatDateForAPI } from "utils/utils";

export default function TimesheetDepartmentOverviewFilters({ filters, setFilters }) {
  const fromDate = filters?.startDate ? new Date(filters.startDate) : undefined;
  const toDate = filters?.endDate ? new Date(filters.endDate) : undefined;

  const handleDepartmentChange = (value) => {
    setFilters({
      ...filters,
      departmentId: value,
    });
  };

  const handleDateChange = (newDate) => {
    setFilters({
      ...filters,
      startDate: newDate?.from ? formatDateForAPI(newDate.from) : undefined,
      endDate: newDate?.to ? formatDateForAPI(newDate.to) : undefined,
    });
  };

  return (
    <div className="flex gap-6 items-center">
      <DepartmentCombobox
        value={filters?.departmentId}
        onChange={handleDepartmentChange}
        hideLabel={true}
      />
      <CalendarDatePicker
        date={{ from: fromDate, to: toDate }}
        setDate={handleDateChange}
      />
    </div>
  );
}
